// extracted by mini-css-extract-plugin
export default {"btn":"style_btn__fCc7N","primary":"style_primary__e6wus","secondary":"style_secondary__jbbnR"};